export const formatNumber = (value: any) => Number(value || 0).toLocaleString();

export const formatMoney = (value: any) => {
  const n = Number(value || 0);
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000_000) return `${(n / 1_000_000_000_000).toFixed(2)} T`;
  if (abs >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(2)} B`;
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(2)} M`;
  return n.toLocaleString();
};

export const formatPercent = (value: any) => {
  if (value === null || value === undefined || value === '') return '-';
  return `${Number(value).toFixed(2)}%`;
};
